import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  tripsList,
} from 'redux/reducers'
import {
  navViewTripAsList,
  navViewTripAsMap,
  navAddTrip,
  navEditTrip,
} from 'redux/actions'

import Component from './component'

const mapStateToProps = state => ({
  tripsList: tripsList(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      viewTripAsList: navViewTripAsList,
      viewTripAsMap: navViewTripAsMap,
      addTrip: navAddTrip,
      editTrip: navEditTrip,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripsListScene/index.js